export default class FormSubmissionDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { submissionDate: json.submissionDate && new Date(json.submissionDate) });
    }
}
